import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const processusEndpoint = `${apiUrl}/smq/Processus`;

const getResponseData = (response) => {
  const payload = response?.data;

  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }

  return payload;
};

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service des paramétrages de processus est indisponible";

const request = async (operation) => {
  try {
    return getResponseData(await operation());
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

const ProcessusService = {
  getProcessus() {
    return request(() => axios.get(processusEndpoint));
  },

  getCategories() {
    return request(() => axios.get(`${processusEndpoint}/categories`));
  },

  getReferentiels() {
    return request(() => axios.get(`${processusEndpoint}/referentiels`));
  },

  getReferentielById(referentielId) {
    return request(() =>
      axios.get(`${processusEndpoint}/referentiel/${referentielId}`)
    );
  },

  createReferentiel(data) {
    return request(() =>
      axios.post(`${processusEndpoint}/referentiel`, data)
    );
  },

  updateReferentiel(referentielId, data) {
    return request(() =>
      axios.put(`${processusEndpoint}/referentiel/${referentielId}`, data)
    );
  },

  deleteReferentiel(referentielId) {
    return request(() =>
      axios.delete(`${processusEndpoint}/referentiel/${referentielId}`)
    );
  },
  getCartographie() {
    return request(() => axios.get(`${processusEndpoint}/cartographie`));
  },
  getCartographieProcessus() {
    return request(() =>
      axios.get(`${processusEndpoint}/cartographie_processus`)
    );
  },
  getDirections() {
    return request(() => axios.get(`${processusEndpoint}/directions`));
  },
  createDirection(data) {
    return request(() => axios.post(`${processusEndpoint}/direction`, data));
  },
  updateDirection(directionId, data) {
    return request(() =>
      axios.put(`${processusEndpoint}/direction/${directionId}`, data)
    );
  },
  deleteDirection(directionId) {
    return request(() =>
      axios.delete(`${processusEndpoint}/direction/${directionId}`)
    );
  },
  getProcessusByDirection(directionId) {
    return request(() =>
      axios.get(`${processusEndpoint}/direction_processus/${directionId}`)
    );
  },
  createProcessus(data) {
    return request(() => axios.post(processusEndpoint, data));
  },
  updateProcessus(processusId, data) {
    return request(() =>
      axios.put(`${processusEndpoint}/processus/${processusId}`, data)
    );
  },
};

export default ProcessusService;
